import { BrokerExtensions } from "@primaria/plugins-core";
import { RemoveHistoryItemHandler } from "./handler";
import { BrokerDisposableHandler } from "@uxland/primary-shell";

let request: BrokerDisposableHandler;

export const bootstrapRemoveHistoryItem = (broker: BrokerExtensions) => {
  request = broker.registerRequest("remove_history_item_request", RemoveHistoryItemHandler);
};

export const teardownRemoveHistoryItem = () => {
  request?.dispose();
};